import { createSlice } from "@reduxjs/toolkit";

export type AppSliceState = {};

const initialState: AppSliceState = {};

export const appSlice = createSlice({
   name: "app",
   initialState,
   reducers: {
      resetAppState: () => {},
      loadApp: () => {},
      loadUserRelatedData: () => {},
   },
});
